import type {
  FullUserCourse,
  FullUserCourseTemplate,
  UserCourseExercise,
  UserCourseTemplateExercise,
} from "api/schemas/UserCourse";

export const convertTemplateToUserCourse = (template: FullUserCourseTemplate) => {
  const newCourse: FullUserCourse = {
    exercises: convertTemplateExercisesToUsercourseExercises(template.exercises),
    lessons: template.lessons,
    max_exercises_per_day: template.max_exercises_per_day,
    functional_test: template.functional_test,
    health_form_type: template.health_form_type,
    strategy: "custom",
  };
  return newCourse;
};

const convertTemplateExercisesToUsercourseExercises = (
  exercises: UserCourseTemplateExercise[]
): UserCourseExercise[] => {
  const deepCopy: UserCourseTemplateExercise[] = JSON.parse(JSON.stringify(exercises));
  return deepCopy.map(e => ({
    current_level: 1,
    active: false,
    ...e,
  }));
};
